import { render } from "./DialogEditNote.vue?vue&type=template&id=38e21aa6&scoped=true"
import script from "./DialogEditNote.vue?vue&type=script&lang=js"
export * from "./DialogEditNote.vue?vue&type=script&lang=js"

import "./DialogEditNote.vue?vue&type=style&index=0&id=38e21aa6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38e21aa6"]])

export default __exports__